import classnames from "classnames";
import { nanoid } from "nanoid";
import CustomImage from "../../../components/core/CustomImage/CustomImage";
import classes from "../../../styles/Home.module.scss";
import { useEffect, useRef } from "react";
import Carousel from "react-multi-carousel";

function OurClientBase({ brands, showItems, className }) {
  // const scrollboxRef = useRef();

  // useEffect(() => {
  //   setInterval(() => {
  //     const scrollboxRefCurrent = scrollboxRef.current;
  //     if (scrollboxRefCurrent.scrollLeft !== scrollboxRefCurrent.scrollWidth) {
  //       scrollboxRefCurrent.scrollTo(scrollboxRefCurrent.scrollLeft + 1, 0);
  //     }

  //   }, 15);
  // }, []);

  return (
    <div className={classnames(className)}>
      <div className={classnames(classes.heading, "heading")}>
        Trusted by Leading Brands
      </div>
      {/* <div
        className={classnames(
          classes.flex_box_brands,
          classes.trustedByLeadingBrands,
          classes.swipe
        )}
      > */}
      <Carousel
        additionalTransfrom={0}
        autoPlay
        autoPlaySpeed={1000}
        centerMode={false}
        className=""
        // containerClass="container-with-dots"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        // renderArrowsWhenDisabled={false}
        // renderButtonGroupOutside={false}
        // renderDotsOutside={false}
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 8,
            partialVisibilityGutter: 40,
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0,
            },
            items: 4,
            partialVisibilityGutter: 30,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464,
            },
            items: 6,
            partialVisibilityGutter: 30,
          },
        }}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots={false}
        sliderClass=""
        slidesToSlide={1}
        swipeable
      >
        {/* <div
          className={classnames(
            // classes.flex_box_brands,
            // classes.trustedByLeadingBrands
            // classes.swipe
          )}
        > */}
          {showItems
            ? brands.slice(0, showItems).map((brand, index) => {
                return (
                  <CustomImage
                    src={brand.image}
                    alt={brand.name}
                    title={brand.name}
                    className={classnames(classes.brandimage)}
                    key={nanoid()}
                  />
                );
              })
            : brands.map((brand) => {
                return (
                  <CustomImage
                    src={brand.image}
                    alt={brand.name}
                    title={brand.name}
                    className={classes.brandimage}
                    key={nanoid()}
                  />
                );
              })}
        {/* </div> */}
      </Carousel>
    </div>
  );
}
export default OurClientBase;
